module.exports = __webpack_public_path__ + "static/media/soviet_headquarters_front.224be9c9.png";